exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-datepicker__input-container input {\n    font-size: 12pt;\n    font-family: 'Avenir MediumOblique';\n    color: #444445;\n    text-align: center;\n    border: 3px solid #979797;\n    border-radius: 0pt;\n    margin-top: 10px;\n    height:1px;\n    background-color: transparent;\n    width: 120px;\n}", ""]);

// exports
